import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-slate-800/60 bg-slate-950 text-slate-400" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-8">
        <div className="flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <img
              src="/brand/finch-partners.webp"
              alt="Finch & Partners"
              className="h-10 w-auto object-contain opacity-90"
            />
            <div>
              <div className="font-heading text-sm font-semibold tracking-wide text-amber-400">
                FINCH &amp; PARTNERS
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">
                Strategic Advisoring
              </div>
            </div>
          </div>
          <div className="text-xs">
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
              <a
                href="https://www.finchnpartners.com"
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-amber-400 hover:text-amber-300"
                data-testid="footer-website"
              >
                www.finchnpartners.com
              </a>
              <span className="text-slate-600">·</span>
              <span>{t("app_name")}</span>
              <span className="text-slate-600">·</span>
              <span>Powered by Claude Sonnet 4.5</span>
            </div>
            <div className="mt-1.5 text-[11px] text-slate-500">
              © {year} Finch &amp; Partners Strategic Advisoring — {lang === "it" ? "Tutti i diritti riservati" : "All rights reserved"}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
